import { Component, Inject, OnInit } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { AuthService } from "@core/auth.service";
import { IonicModule, ModalController } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { ReferFriendComponent } from "../refer-friend/refer-friend.component";
import { WhatsOnDetailComponent } from "../whats-on-detail/whats-on-detail.component";
import { SwiperModule } from 'swiper/angular';
@Component({
    selector: "app-whats-on",
    templateUrl: "./whats-on.page.html",
    styleUrls: ["./whats-on.page.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe, SwiperModule],
})
export class WhatsOnPage implements OnInit {
  userId: string;
  constructor(
    private bottomSheetRef: MatBottomSheetRef<WhatsOnPage>,
    private modalController: ModalController,
    private analytics: AngularFireAnalytics,
    private bottomSheet: MatBottomSheet,
    private authService: AuthService,
    public translate: TranslateService,
    private GTMSegment: GTMSegmentService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public whatsOnData: any
  ) {
    this.GTMSegment.GTMPopupInitialization("WhatsOnPage");
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );
  }

  slideOpts = {
    initialSlide: 0,
    speed: 400,
    slidesPerView: 1.25,
    spaceBetween: 20,
    centeredSlides: false,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 20,
  };

  async ngOnInit() {
    await this.authService
      ?.getUid("WhatsOnPage")
      ?.then((uid) => {
        this.userId = uid;
        this.analytics.logEvent("what's_on_screen", { userId: this.userId });
      })
      .catch((error) => {
        return error;
      });
  }
  

  closeDialog() {
    this.bottomSheetRef.dismiss();
  }

  async openInvitationPage() {
    this.bottomSheetRef.dismiss();
    const modal = await this.modalController.create({
      component: ReferFriendComponent,
      cssClass: "",
    });

    return await modal.present();
  }

  openBlogDetailsPage(detailObj, type) {
    this.bottomSheet.open(WhatsOnDetailComponent, {
      panelClass: "whats-on-bottom-sheet",
      data: {
        detailObj,
        type,
      },
    });
  }
}
